namespace TabAurous.Finance {
    export interface ServiceInwardForm {
        TransId: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        LedgerId: Serenity.LookupEditor;
        LedgerName: Serenity.StringEditor;
        Address1: Serenity.TextAreaEditor;
        State: Serenity.StringEditor;
        Country: Serenity.StringEditor;
        TaxLedgerId: Serenity.IntegerEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchangeRate: Serenity.DecimalEditor;
        UserId: Serenity.LookupEditor;
        RefNo: Serenity.StringEditor;
        RefDate: Serenity.DateEditor;
        Details: ServiceInwardDetailsEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        TaxDetails: ServiceInwardTaxEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Narration: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class ServiceInwardForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.ServiceInward';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ServiceInwardForm.init)  {
                ServiceInwardForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = s.TextAreaEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.DecimalEditor;
                var w6 = ServiceInwardDetailsEditor;
                var w7 = ServiceInwardTaxEditor;

                Q.initFormType(ServiceInwardForm, [
                    'TransId', w0,
                    'TransDate', w1,
                    'VoucherNo', w0,
                    'LedgerId', w2,
                    'LedgerName', w0,
                    'Address1', w3,
                    'State', w0,
                    'Country', w0,
                    'TaxLedgerId', w4,
                    'CurrencyId', w2,
                    'ExchangeRate', w5,
                    'UserId', w2,
                    'RefNo', w0,
                    'RefDate', w1,
                    'Details', w6,
                    'VoucherTypeId', w4,
                    'TaxDetails', w7,
                    'NetAmount', w5,
                    'TaxAmount', w5,
                    'GrossAmount', w5,
                    'Narration', w0,
                    'CompanyId', w4,
                    'FinancialYearId', w4
                ]);
            }
        }
    }
}
